export const accessCodes = [
  "KVT213",
  "SEU533",
  "ORF617",
  "FRL278",
  "WDF395",
  "XSB283",
];

export const randomCode = () =>
  accessCodes[Math.floor(Math.random() * accessCodes.length)];
